module.exports = __webpack_public_path__ + "img/1557614096924352514.2369ec2a.png";